import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.sort";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.pad-start";
import "core-js/modules/es.string.search";
import "regenerator-runtime/runtime";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import axios from 'axios';
import moment from 'moment';
import _ from 'lodash'; // import sleep from 'sleep-promise'

import qs from 'query-string'; // ------------------------------

var state = function state() {
  var year = moment().format('YYYY');

  var months = _.times(12, function (n) {
    return "".concat(n + 1);
  });

  return {
    news_api: '/api/news/list.json',
    news_list: [],
    page_info: {
      results: 0,
      limit: 10,
      page: 1
    },
    // FIXME
    // shop配列がハードコーディングになるため
    // MT経由でshop/index.jsonを生成して
    // 店舗情報を取得した方が良さそう
    //
    // とりあえず店舗情報を直で追加（10/28 酒井）
    shop: null,
    shops: [{
      id: "group",
      name: "祇園つじりグループ"
    }, {
      id: "giontsujiri-honten",
      name: "宇治茶祇園辻利本店"
    }, {
      id: "hachijo-guchi",
      name: "京都駅八条口店"
    }, {
      id: "shinsaibashi-daimaru",
      name: "大丸心斎橋店"
    }, {
      id: "giontsujiri-tabisora",
      name: "大阪国際(伊丹)空港 旅・SORA店"
    }, {
      id: "skytree",
      name: "東京ソラマチ店"
    }, {
      id: "saryotsujiri-honten",
      name: "茶寮都路里祇園本店"
    }, {
      id: "kyoto-isetan",
      name: "京都伊勢丹"
    }, {
      id: "saryo-shinsaibashi-daimaru",
      name: "大丸心斎橋店"
    }, // { id: "kodaiji", name: "高台寺店" },
    {
      id: "tokyo-daimaru",
      name: "東京大丸店"
    }],
    calendar: {
      year: year,
      yearMonth: null,
      months: months
    }
  };
}; // ------------------------------


var getters = {
  newsList: function newsList(state) {
    try {
      // 副作用を防ぐため配列をcloneDeepする
      var news_list = _.cloneDeep(state.news_list);

      var currentPage = "".concat(state.page_info.page);
      currentPage = Number(currentPage);
      var query = qs.parse(location.search); // routeQueryにdateを持つ場合はdateで絞り込む

      if (query.date) {
        news_list = _.filter(news_list, function (i) {
          if (new RegExp("^".concat(query.date)).test(i.date)) {
            return i;
          }
        });
      } // routeQueryにshopを持つ場合はshop.basenameで絞り込む


      if (query.shop) {
        news_list = _.filter(news_list, function (i) {
          if (query.shop == i.shop.basename) {
            return i;
          }
        });
      } // 配列を{limit}件毎に分割する


      var allList = _.chunk(news_list, state.page_info.limit);

      currentPage = currentPage - 1; // if ( _.isNaN(currentPage) ) {
      //   currentPage = 0
      // }

      return {
        count: allList.length,
        entries: allList[currentPage]
      };
    } catch (error) {
      return null;
    }
  },
  newsListAll: function newsListAll(state) {
    try {
      return state.news_list;
    } catch (error) {
      return [];
    }
  },
  getBasenames: function getBasenames(state) {
    return function () {
      try {
        var basenames = [];

        _.map(state.news_list, function (i) {
          basenames.push(i.shop.basename);
        });

        basenames = _.uniq(basenames);
        return basenames;
      } catch (error) {
        return null;
      }
    };
  },
  entryArchives: function entryArchives(state) {
    try {
      // 副作用対策
      var news = _.cloneDeep(state.news_list); // カレンダー用にentryをグルーピング


      var years = _.groupBy(news, 'entry_year');

      var months = _.groupBy(news, 'entry_month');

      var dates = _.groupBy(news, 'entry_date');

      return {
        years: years,
        months: months,
        dates: dates
      };
    } catch (error) {
      return null;
    }
  },
  hasMonthlyEntries: function hasMonthlyEntries(state, getters) {
    return function (month) {
      try {
        // monthをゼロ埋め
        month = _.padStart(month, 2, '00');
        var yearMonth = "".concat(state.calendar.year, "-").concat(month); // entryに対象の月を持つ場合trueを返す

        if (getters.entryArchives.months[yearMonth]) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    };
  },
  hasShopEntries: function hasShopEntries(state) {
    return function (shopname) {
      try {
        // ショップ記事を持つ場合はtrueを返す
        var list = _.groupBy(state.news_list, 'shop.basename');

        if (list[shopname]) {
          return true;
        } else {
          return false;
        }
      } catch (error) {
        return false;
      }
    };
  },
  shopNewsList: function shopNewsList(state) {
    return function (shopname) {
      var news_list = _.cloneDeep(state.news_list);

      try {
        var list = news_list.filter(function (item, index, array) {
          if (item.shop.basename === shopname) return item;
        });
        list.sort(function (a, b) {
          if (moment(a.date) > moment(b.date)) {
            return -1;
          }

          if (moment(a.date) < moment(b.date)) {
            return 1;
          }

          return 0;
        });
        return list;
      } catch (error) {
        return false;
      }
    };
  }
}; // ------------------------------

var mutations = {
  setNewsList: function setNewsList(state, payload) {
    // 生のapiの結果をstateに登録
    state.news_list = payload.newsList; // 検索用にデータを加工しておく

    _.map(state.news_list, function (i) {
      i.entry_year = moment(i.date).format('YYYY');
      i.entry_month = moment(i.date).format('YYYY-MM');
      i.entry_date = moment(i.date).format('YYYY-MM-DD');
    }); // paginate用のオブジェクトを生成
    // state.page_info.page = 1


    state.page_info.results = state.news_list.length;
  },
  resetNewsList: function resetNewsList(state) {
    state.news_list = null;
  },
  // カレンダー切り替えmethods
  nextYear: function nextYear(state, payload) {
    state.calendar.year++;
  },
  currentYear: function currentYear(state, payload) {
    state.calendar.year = moment().format('YYYY');
  },
  prevYear: function prevYear(state, payload) {
    state.calendar.year--;
  },
  setYearMonth: function setYearMonth(state, payload) {
    state.calendar.yearMonth = payload;
  },
  // paginate関連
  setPage: function setPage(state, payload) {
    state.page_info.page = Number(payload);
  },
  setShop: function setShop(state, payload) {
    state.shop = payload;
  }
}; // ------------------------------

var actions = {
  getNewList: function () {
    var _getNewList = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, state, _ref2, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit, state = _ref.state;
              _context.prev = 1;
              commit('resetNewsList');
              _context.next = 5;
              return axios.get(state.news_api);

            case 5:
              _ref2 = _context.sent;
              data = _ref2.data;
              commit('setNewsList', data);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              console.error("Error! HTTP states: ".concat(_context.t0));

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    function getNewList(_x) {
      return _getNewList.apply(this, arguments);
    }

    return getNewList;
  }(),
  changePage: function changePage(_ref3, page) {
    var commit = _ref3.commit;

    try {
      var query = qs.parse(location.search);
      query.page = page; // routerQueryにpush

      var stringified = qs.stringify(query);
      var next = "".concat(location.pathname);

      if (page) {
        next = "".concat(location.pathname, "?").concat(stringified);
      }

      window.history.pushState(null, null, next);
      commit('setPage', page);
    } catch (error) {
      console.error({
        error: error
      });
    }
  },
  setYearMonth: function () {
    var _setYearMonth = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref4, month) {
      var commit, state, yearMonth, stringified, next;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref4.commit, state = _ref4.state;

              try {
                // monthをゼロ埋め
                month = _.padStart(month, 2, '00');
                yearMonth = "".concat(state.calendar.year, "-").concat(month); // routerQueryにpush

                stringified = qs.stringify({
                  date: yearMonth
                });
                next = "".concat(location.pathname, "?").concat(stringified);
                window.history.pushState(null, null, next);
                commit('setYearMonth', yearMonth);
              } catch (error) {
                console.error({
                  error: error
                });
              }

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function setYearMonth(_x2, _x3) {
      return _setYearMonth.apply(this, arguments);
    }

    return setYearMonth;
  }(),
  setShop: function () {
    var _setShop = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref5, shop) {
      var commit, stringified, next;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref5.commit;

              try {
                // routerQueryにpush
                stringified = qs.stringify({
                  shop: shop
                });
                next = "".concat(location.pathname);

                if (shop) {
                  next = "".concat(location.pathname, "?").concat(stringified);
                }

                window.history.pushState(null, null, next);
                commit('setShop', shop);
              } catch (error) {
                console.error({
                  error: error
                });
              }

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function setShop(_x4, _x5) {
      return _setShop.apply(this, arguments);
    }

    return setShop;
  }()
}; // ------------------------------

export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations,
  getters: getters
};